import LightWithFade from "./LightWithFade";

export default function Stele() {
  return (
    <group position={[0, 0, 1]} rotation={[0, Math.PI / 2, 0]} >
        <LightWithFade
            type="rectArea"
            
            duration={10}
            finalIntensity={100}
            color="aqua"
            width={3}
            height={3}
            position={[0,2,-1]}
            rotation={[-Math.PI,0,0]}
            easing/>
      <mesh position={[0, 0, 0]}>
        <cylinderGeometry args={[0.2, 0.25, 0.5, 5]}/>
        <meshStandardMaterial color={"#white"} roughness={1} metalness={0.9} />
      </mesh>
      <mesh position={[0, -1.75, 0]}>
        <cylinderGeometry args={[0.75, 0.75, 0.25, 32]} />
        <meshStandardMaterial color={"#white"} roughness={1} metalness={0.9} />
      </mesh>
    </group>
  );
}